"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SendSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var SendSVG = function SendSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.971,4.565l-7.74,24.09a1.98,1.98,0,0,1-1.69,1.37,1.785,1.785,0,0,1-.23.02,1.978,1.978,0,0,1-1.72-1l-5.21-8.94,1.46-1.46,5.45-5.46a1,1,0,0,0-1.41-1.41l-6.86,6.86-9.19-6.12a2,2,0,0,1,.56-3.59l24.12-6.89a1.988,1.988,0,0,1,1.99.53A2.018,2.018,0,0,1,29.971,4.565Z"
  }));
};
exports.SendSVG = SendSVG;
SendSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SendSVG);
exports.default = _default;